export enum Environment {
  LOCAL = 'local',
  DEV = 'dev',
  INT = 'int',
  PROD = 'prod',
  ON_PREM = 'onprem',
}
